import type { RoomOptions } from 'livekit-client';

import { SPEAKER_SELECTION_SUPPORTED } from '#features/media-window/audioRouting';
import { loadDevicePreference } from './devicePreference';

/**
 * Устройства, которые человек выбрал в проверке, — для новой комнаты LiveKit.
 *
 * <p>Без этого раздел проверки врал бы самым обидным образом: человек выбирает гарнитуру, слышит
 * себя в записи, видит зелёное "в порядке" — и входит в разговор, где LiveKit берёт системное
 * устройство по умолчанию, то есть микрофон вебкамеры, и его снова не слышно. Обещание "выбор
 * запомнен" имеет смысл ровно в том месте, где идёт разговор, а не в настройках.
 *
 * <p>Выбор — пожелание: устройство могли вынуть. `deviceId` передаётся без `exact`, поэтому
 * исчезнувшее устройство не роняет вход в разговор, а молча уступает системному.
 */
export const preferredRoomDevices = (): Pick<
  RoomOptions,
  'audioCaptureDefaults' | 'videoCaptureDefaults'
> & { audioOutput?: { deviceId?: string } } => {
  const mic = loadDevicePreference('mic');
  const camera = loadDevicePreference('camera');
  const speaker = loadDevicePreference('speaker');

  return {
    ...(mic ? { audioCaptureDefaults: { deviceId: mic } } : {}),
    ...(camera ? { videoCaptureDefaults: { deviceId: camera } } : {}),
    // Выход выбираем только там, где браузер это умеет: на iPhone и в приложении маршрутом звука
    // распоряжается система, и попытка назначить его молча игнорируется.
    ...(speaker && SPEAKER_SELECTION_SUPPORTED ? { audioOutput: { deviceId: speaker } } : {}),
  };
};
